import { render, staticRenderFns } from "./Proyects.vue?vue&type=template&id=09495d89&scoped=true&"
import script from "./Proyects.vue?vue&type=script&lang=js&"
export * from "./Proyects.vue?vue&type=script&lang=js&"
import style0 from "./Proyects.vue?vue&type=style&index=0&id=09495d89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09495d89",
  null
  
)

export default component.exports